import React from "react";

const FavTopSearch = () => {
    return (
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <div className="_nft_settings_main_bottom">
                        <div className="_nft_settings_main_bottom_heading">
                            <div className="_fav_search_wrap">
                                <span className="_fav_search_ic"><svg xmlns="http://www.w3.org/2000/svg" width="23"
                                    height="23" fill="none" viewBox="0 0 23 23">
                                    <path fill="#797A7E" fill-rule="evenodd"
                                        d="M4.43 16.838a8.397 8.397 0 1 1 12.647-.888l3.313 3.313c.864.864-.433 2.16-1.297 1.296l-3.273-3.273a8.397 8.397 0 0 1-11.39-.448ZM15.006 6.26a6.563 6.563 0 1 0-9.282 9.282 6.563 6.563 0 0 0 9.282-9.282Z"
                                        clip-rule="evenodd" />
                                </svg>
                                </span>
                                <input className="_fav_search_input" type="text" name="search" id="search"
                                    placeholder="Search" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <div className="_creator_top_right">
                        <div className="btn-group _creator_top_right_btn_wrap">
                            <button className="btn dropdown-toggle _creator_top_right_btn" type="button"
                                id="defaultDropdown" data-bs-toggle="dropdown" data-bs-auto-close="true"
                                aria-expanded="false">
                                Featured
                            </button>
                            <ul className="dropdown-menu _creator_top_btn_drop" aria-labelledby="defaultDropdown">
                                <li><a className="dropdown-item _creator_top_btn_drop_item" href="#0">Best selling</a>
                                </li>
                                <li><a className="dropdown-item _creator_top_btn_drop_item" href="#0">Popular items</a>
                                </li>
                                <li><a className="dropdown-item _creator_top_btn_drop_item" href="#0">New items</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default FavTopSearch;